import { render, staticRenderFns } from "./anva-copyright.vue?vue&type=template&id=53669db2&scoped=true"
import script from "./anva-copyright.vue?vue&type=script&lang=js"
export * from "./anva-copyright.vue?vue&type=script&lang=js"
import style0 from "./anva-copyright.vue?vue&type=style&index=0&id=53669db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53669db2",
  null
  
)

export default component.exports